// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";

import FlexColumn from "common/components/styled-components/FlexColumn";
import StackedBar from "./StackedBar";
import SectionDescription from "./styled-components/SectionDescription";

interface HouseholdHabitsProps {
  averageFootprint: number;
  userFootprint: number;
  averageSectorFootprint: number;
  userSectorFootprint: number;
}

function HouseholdHabits({
  averageFootprint,
  userFootprint,
  averageSectorFootprint,
  userSectorFootprint,
}: HouseholdHabitsProps) {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  return (
    <FlexColumn gap={upDesktopScreen ? 20 : 24}>
      <StackedBar
        title="Hábitos de hogar"
        averageColor="#e8153b"
        averageValue={averageSectorFootprint}
        userColor="#eb7187"
        userValue={userSectorFootprint}
        total={Math.max(averageFootprint, userFootprint)}
      />
      <SectionDescription>
        Deberás modificar algunos de tu hábitos en casa para mejorar tu huella
        en este factor, por ejemplo puedes desconectar los electrodomésticos que
        no estés usando, realizar un reciclaje más pormenorizado separando más
        los diferentes residuos y ser más eficiente en el uso de la energía
        durante tus actividades cotidianas como cocinar.
      </SectionDescription>
    </FlexColumn>
  );
}

export default HouseholdHabits;
